import { SearchSelect } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { AssetCustomView } from "domain/asset-management/assets";
import { StoreState } from "store";

const collectGroups = (views: AssetCustomView[]): AssetCustomView[] =>
    views.flatMap((view) => (view.folder ? collectGroups(view.childrenViews) : [view]));

interface Props {
    name: string;
    value: string;
    onChange: (value: string) => void;
    excludeGroupUuid?: string;
    dropdownMaxHeight?: number;
    disabled?: boolean;
}

export const GroupSelect = (props: Props) => {
    const { t } = useTranslation();
    const storeViews = useSelector((state: StoreState) => state.assetViewsReducer.views);
    const dropdownMaxHeight = props.dropdownMaxHeight ?? 250;
    const disabled = props.disabled ?? false;

    const groupItems = [
        { value: "", label: t("AssetManagement.selectGroup.noGroup") },
        ...collectGroups(storeViews ?? [])
            .filter((view) => view.uuid !== props.excludeGroupUuid)
            .map((view) => ({ value: view.uuid, label: view.name })),
    ];

    return (
        <SearchSelect
            name={props.name}
            label={t("AssetManagement.selectGroup.label")}
            placeholder={t("AssetManagement.selectGroup.label")}
            selectedByDefault={props.value}
            items={groupItems}
            onSelection={(selected) => props.onChange(String(selected))}
            closeOnSelection={true}
            dropdownMaxHeight={dropdownMaxHeight}
            disabled={disabled}
        />
    );
};
